import React, { useEffect } from 'react';
import { FormattedMessage, } from 'react-intl';
import { Button, Row, Col, Space, } from 'antd';
import notification from './services/notification';

import { ArrowsClockwiseIcon, } from '@phosphor-icons/react';
import 'dayjs/locale/nl';

// This helper gives the notification if a new version is available.
// It is placed in the App component, so it will be triggered on every page.
// This is needed because the service worker can only be registered in the index.js file,
// and we need the translation also works in the refresh notification.
const RefreshRootMsg = ({
    isNotificationOpen,
    ...props
}) => {


    useEffect(() => {
        // openNotification();

        // Set timeout to make sure view has renderd.
        setTimeout(() => {
            if (isNotificationOpen) {
                openNotification();
            }
        }, 1500);

        // eslint-disable-next-line
    }, [isNotificationOpen]);

    const openNotification = () => {
        notification.open({
            message: <strong><FormattedMessage id="new-version" /></strong>,
            type: 'info',
            description: <Row>
                <Col span={24}>
                    <FormattedMessage id="new-version-info" />
                </Col>
            </Row>,
            className: 'notification-refresh',
            placement: 'bottomLeft',
            duration: 0,
            key: 1,
            actions: (
                <Space>
                    <Button size="small" onClick={e => window.location.reload()}><ArrowsClockwiseIcon size={16} className="mr-1" /> Refresh</Button>
                </Space>),
        });
    };
    // return (<div></div>);
};

export default RefreshRootMsg;
